export default __webpack_public_path__ + "static/media/img_22.a10a3bce.JPG";